import React, { useState } from "react";
import "./ChatBar.css";
import { sendMessageToOpenAI } from "../services/openai";

function ChatBar({ onSendMessage, onShowTemplate2, onShowTemplate3, onShowTemplate4, onShowTemplate5, onShowTemplate6, onShowTemplate7, onShowTemplate8, onShowTemplate9 }) {
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = async () => {
    if (message.trim() && !isLoading) {
      setIsLoading(true);
      try {
        const response = await sendMessageToOpenAI(message);
        console.log("OpenAI Response:", response);

        if (typeof response === "object") {
          if (response.template === "template2" && response.type) {
            // Ensure we have a valid type before showing template2
            const type = parseInt(response.type);
            if (type >= 1 && type <= 4) {
              onShowTemplate2(response);
            } else {
              console.error("Invalid template2 type:", response.type);
            }
          } else if (response.template === "template3") {
            onShowTemplate3(response.answer);
          }
        }
        if (response === "template4") {
          onShowTemplate4();
        } else
        if (response === "template5") {
          onShowTemplate5();
        } else if (response === "template1") {
          onSendMessage();
        } else if (response === "template6") {
          onShowTemplate6();
        } else if (response === "template7") {
          onShowTemplate7();
        } else if (response === "template8") {
          onShowTemplate8();
        } else if (response === "template9") {
          onShowTemplate9();
        }
        setMessage("");
      } catch (error) {
        console.error("Error:", error);
        // You might want to show an error message to the user here
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleKeyPress = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-bar">
      <div className="chat-input-container">
        <input type="text" placeholder="Ask me anything..." className="chat-input" value={message} onChange={e => setMessage(e.target.value)} onKeyPress={handleKeyPress} disabled={isLoading} />
        <button className="send-button" onClick={handleSend} disabled={isLoading}>
          {isLoading ? (
            <div className="loading-spinner" />
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

export default ChatBar;
